export default "__VITE_ASSET__BPiUQoL$__"